import { FiltersIcon } from 'de-suite-me-ui'

export default FiltersIcon
